<template>
  <v-navigation-drawer
    permanent
    fixed
    app
    width="250"
    ref="sidebar"
  >
    <v-sheet color="white" class="pt-5 px-5 pb-2">
      <v-img :src="require('@/assets/logo_dark.png')" contain width="200px" height="50px"></v-img>
    </v-sheet>
    <v-list nav class="primary--text">
      <v-list-item class="text-center title primary" dark>
        <v-list-item-content>
          <v-list-item-title>
            {{ $t('Global.App.title') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider class="my-3"></v-divider>
      <v-list-group ref="user-section">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>{{user.firstName}} {{user.lastName}}</v-list-item-title>
            <v-list-item-subtitle>{{user.email}}</v-list-item-subtitle>
          </v-list-item-content>
        </template>
        <v-list-item>
          <v-list-item-content>
            <v-tooltip right>
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  block
                  x-small
                  color="warning"
                  @click="$store.commit('qlik/setContextualHelp', !$store.state.qlik.contextualHelp)"
                  :outlined="$store.state.qlik.contextualHelp"
                  v-on="on"
                  v-bind="attrs"
                >
                  {{ $store.state.qlik.contextualHelp ? $t('Menu.Sidebar.disableContextualHelp') : $t('Menu.Sidebar.enableContextualHelp') }}
                </v-btn>
              </template>
              {{$t('Menu.Sidebar.contextualHelpDescription')}}
            </v-tooltip>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="$store.commit('doc/setShow', true)">
          <v-list-item-action>
            <v-icon>quiz</v-icon>
          </v-list-item-action>
          <v-list-item-title>
            {{ $t('Menu.Sidebar.help') }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item @click="$store.commit('lang/setShowLanguages', true)">
          <v-list-item-action>
            <v-icon>language</v-icon>
          </v-list-item-action>
          <v-list-item-title>
            {{ $t('Menu.Sidebar.language') }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item @click="showSecurity = true">
          <v-list-item-action>
            <v-icon>admin_panel_settings</v-icon>
          </v-list-item-action>
          <v-list-item-title>
            {{ $t('Menu.Sidebar.security') }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item @click="$store.dispatch('auth/disconnectUser')">
          <v-list-item-action>
            <v-icon>logout</v-icon>
          </v-list-item-action>
          <v-list-item-title>
            {{ $t('Menu.Sidebar.logout') }}
          </v-list-item-title>
        </v-list-item>
      </v-list-group>

      <v-divider class="my-3"></v-divider>
      <template v-for="(item, index) in items.filter(item => item.type === 'main')">
        <v-list-item :key="'item' + index" :to="item.to">
          <v-list-item-action v-if="item.icon">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.text }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-list-group v-if="appItems.length" ref="app-section" :value="true">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>{{ $t('Menu.Sidebar.applications') }}</v-list-item-title>
          </v-list-item-content>
        </template>
        <template v-for="(item, index) in appItems">
          <v-list-item :key="'item' + index" :to="item.to" :color="item.color">
            <v-list-item-action v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list-group>

      <v-list-group v-if="isAdmin" ref="admin-section">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>{{ $t('Menu.Sidebar.administration') }}</v-list-item-title>
          </v-list-item-content>
        </template>
        <template v-for="(item, index) in adminItems">
        <v-list-item :key="'item' + index" :to="item.to">
          <v-list-item-action v-if="item.icon">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.text }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      </v-list-group>
    </v-list>
    <template v-slot:append>
      <v-btn block text @click="$store.commit('contact/showModal')">
        <v-icon left>mail</v-icon>
        {{ $t('Menu.Sidebar.contact') }}
      </v-btn>
    </template>
    <UserSecurityModal :show="showSecurity" @close="showSecurity = false" />
  </v-navigation-drawer>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
import UserSecurityModal from '@/components/User/UserSecurityModal'
import {
  ROUTE_MY_DASHBOARD,
  ROUTE_ADMIN_USERS,
  ROUTE_ADMIN_DOCUMENTS,
  ROUTE_ADMIN_NEWS,
  ROUTE_ADMIN_APPS,
  ROUTE_MY_APP
} from '@/router/index'

export default {
  name: 'TheSideBar',
  components: { UserSecurityModal },
  data: () => ({
    showSecurity: false
  }),
  computed: {
    ...mapState('auth', [
      'user'
    ]),
    ...mapGetters('auth', [
      'isAdmin'
    ]),
    ...mapState('qlik', [
      'apps'
    ]),
    items() {
      return [
        { icon: 'dashboard', text: this.$t('Menu.Sidebar.dashboard'), to: {name: ROUTE_MY_DASHBOARD}, type: 'main' },
        { icon: 'supervised_user_circle', text: this.$t('Menu.Sidebar.users'), to: {name: ROUTE_ADMIN_USERS}, type: 'admin' },
        { icon: 'perm_media', text: this.$t('Menu.Sidebar.news'), to: {name: ROUTE_ADMIN_NEWS}, type: 'admin' },
        { icon: 'folder_open', text: this.$t('Menu.Sidebar.documents'), to: {name: ROUTE_ADMIN_DOCUMENTS}, type: 'admin' },
        { icon: 'apps', text: this.$t('Menu.Sidebar.applications'), to: {name: ROUTE_ADMIN_APPS}, type: 'admin' },
        ...this.apps.map(app => ({
          icon: app.icon,
          color: app.color,
          text: app.name,
          to: {name: ROUTE_MY_APP, params: {id: app.id}},
          type: 'app'
        }))
      ]
    },
    adminItems () {
      return this.items.filter(item => item.type === 'admin')
    },
    appItems () {
      return this.items.filter(item => item.type === 'app')
    }
  }
}
</script>
